module.exports = __webpack_public_path__ + "static/media/6.8cf1e7cd.jpg";